import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App';
import { AppProvider } from './context/AppContext';
import reportWebVitals from './reportWebVitals';
import './index.css';
import "./tailwind/tailwind.dist.css"
import '@tailwindplus/elements';

const root = createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
)

document.documentElement.classList.add('bg-gray-50');
document.documentElement.classList.add('antialiased');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
